import { CommonModule } from '@angular/common';
import { Component, Inject, Input, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CourseManagmentService } from 'src/app/services/course-managment.service';
import { ModalService } from 'src/app/services/modal.service';
import { ParticipantListModalComponent } from '../participant-list-modal/participant-list-modal.component';
import { DeleteModalComponent } from 'src/app/shared/ui-kit/delete-modal/delete-modal.component';
import { AddCourseComponent } from '../add-course/add-course.component';
import { ClubManagmentService } from 'src/app/services/club-managment.service';

@Component({
  selector: 'app-course-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './course-details.component.html',
  styleUrl: './course-details.component.scss'
})
export class CourseDetailsComponent { 
  courseTypeImg: string='';
  tooltipData: any; 

  

  constructor(
    public dialog: MatDialog,
    private modalService: ModalService,
    private courseManagmentService: CourseManagmentService,
    private clubManagmentService: ClubManagmentService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ){}

  ngOnInit() {
    if (this.data) {
      this.tooltipData=this.data.tooltipData
      this.loadCourseImage(this.data.tooltipData.courseCoverPicture);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data.tooltipData'] && changes['data.tooltipData'].currentValue) {
      this.loadCourseImage(this.data.tooltipData.courseCoverPicture);
    }
  }

  loadCourseImage(path: string): void {
    this.courseTypeImg=''
    if (path) {
      this.courseManagmentService.getCourseCreationImageByPath(path)
        .subscribe({
          next: (blob) => {
            this.courseTypeImg = URL.createObjectURL(blob);
          },
          error: () => {
            this.courseTypeImg = '';
          },
        });
    }
  }  
  
  onParticipantListClick(){
      
      this.dialog.closeAll();
          const dialog = this.dialog.open(ParticipantListModalComponent, {
        data: {
          courseId: this.tooltipData.id,
        },
      });
      dialog.afterClosed().subscribe(result => {
        if (result) {
          this.dialog.closeAll();
        }
      });
  
      this.modalService.setDialogRef(dialog);
    
  }

  formatDuration(minutes: number): string {
    const hours = Math.floor(minutes / 60); 
    const remainingMinutes = minutes % 60;
  
    if (hours > 0 && remainingMinutes > 0) {
      return `${hours}H${remainingMinutes}`; 
    } else if (hours > 0) {
      return `${hours}H`; 
    } else {
      return `${remainingMinutes}Min`; 
    }
  }
  

  formatDateString(dateString: string): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = new Intl.DateTimeFormat('fr-FR', { month: 'short' }).format(date);
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }
  
  openSuppModal(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(DeleteModalComponent, {
      data: {
        courseId: this.tooltipData.id,
        title : 'Êtes-vous sûr(e) de vouloir supprimer le cours?',
        description:"La suppression de ce cours pour la journée sélectionnée est définitive. Il ne sera plus affiché dans l'agenda de ce jour"
       }
    });
  }

  openCourseModif(){
    this.dialog.closeAll();
    this.courseManagmentService.resetCourseData()
    this.clubManagmentService.getAllClubs().subscribe(
      (categories: any[]) => {
        const dialog = this.dialog.open(AddCourseComponent, {
          data: {
            clubsList: categories,
            courseId: this.tooltipData.id,
          },
        });
      }
    )
  }
}